import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { Button, Field, Input } from '@/components/ui';
import { AuthLayout } from './AuthLayout';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setLoading(true);
    try {
      await api('/auth/password/forgot', { method: 'POST', body: { email: email.trim() } });
    } finally {
      // 계정이 있는지 여부를 화면으로 드러내지 않는다 — 항상 같은 안내를 보여 준다.
      setSent(true);
      setLoading(false);
    }
  }

  return (
    <AuthLayout
      title="비밀번호 다시 정하기"
      description="가입하신 이메일로 안내 링크를 보내 드릴게요."
      footer={
        <Link to="/login" className="underline">
          로그인 화면으로
        </Link>
      }
    >
      {sent ? (
        <p className="rounded-sm bg-primary-soft px-4 py-3 text-base text-ink">
          입력하신 주소로 안내 메일을 보냈어요. 메일함을 확인해 주세요. 링크는 1시간 동안 열려
          있어요.
        </p>
      ) : (
        <form onSubmit={submit} className="flex flex-col gap-4">
          <Field label="이메일" required>
            <Input
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Field>
          <Button type="submit" block size="lg" loading={loading}>
            안내 메일 받기
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
